import {
    FETCH_BUILD_DISTRIBUTION_SHARED_WITH_ME_BUILDS_SUCCESS,
    FetchBuildDistributionSharedWithMeBuildsSuccessAction,
    ShareBuildDistributionBuildWithTestersSuccessAction,
    UPDATE_BUILD_DISTRIBUTION_BUILD_TESTERS_SUCCESS,
    UPDATE_BUILD_DISTRIBUTION_BUILD_TESTER_NOTES_SUCCESS,
    UpdateBuildDistributionBuildTesterNotesSuccessAction,
    UploadBuildDistributionBuildSuccessAction,
    FETCH_BUILD_DISTRIBUTION_BUCKET_BUILD_SUCCESS,
    FetchBuildDistributionBucketBuildSuccessAction,
    UPDATE_BUILD_DISTRIBUTION_BUCKETS_SUCCESS,
    UpdateDistributionBucketsSuccessAction,
    FetchBuildDistributionBuildWorkItemsTimelineSuccessAction,
    FETCH_BUILD_DISTRIBUTION_BUILD_WORK_ITEMS_TIMELINE_SUCCESS,
    ArchiveBuildDistributionBuildSuccessAction,
    ARCHIVE_BUILD_DISTRIBUTION_BUILD_SUCCESS,
    FETCH_BUILD_DISTRIBUTION_BUCKET_DOWNLOAD_METRICS_SUCCESS,
    FetchBuildDistributionBucketDownloadMetricsSuccessAction,
} from './../actions/buildDistribution';
import { combineReducers } from 'redux';
import {
    FetchBuildDistributionBucketBuildsSuccessAction,
    FetchBuildDistributionBucketsSuccessAction,
    FetchBuildDistributionBucketSuccessAction,
    FETCH_BUILD_DISTRIBUTION_BUCKETS_WITH_RECENT_BUILDS_SUCCESS,
    FETCH_BUILD_DISTRIBUTION_BUCKET_BUILDS_SUCCESS,
    FETCH_BUILD_DISTRIBUTION_BUCKET_SUCCESS,
    NEW_BUILD_DISTRIBUTION_BUCKET_SUCCESS,
    NewBuildDistributionBucketSuccessAction,
    UPDATE_BUILD_DISTRIBUTION_BUCKET_SUCCESS,
    UpdateDistributionBucketSuccessAction,
    ArchiveBuildDistributionBucketSuccessAction,
    ARCHIVE_BUILD_DISTRIBUTION_BUCKET_SUCCESS,
    UPLOAD_BUILD_DISTRIBUTION_BUILD_SUCCESS,
} from '../actions/buildDistribution';
import { BuildDistributionBucket, BuildDistroBucketDownloadMetrics, BuildDistroBuild } from '../types';
// import { FETCH_STATE_SUCCESS, FetchStateSuccessAction } from '../actions/state';
import { FETCH_APP_STATE_SUCCESS, FetchAppStateSuccessAction } from '../actions/app';
import { uniq } from 'lodash';

type BuildDistributionBucketsById = Record<string, BuildDistributionBucket>;
type BucketIdsForAppId = Record<string, string[]>;
type SharedBuildCountsForAppId = Record<string, number>;
type SharedBuildsForAppId = Record<string, string[]>;
type BucketBuildsById = Record<string, BuildDistroBuild>;
type DownloadMetricsByBucketId = Record<string, BuildDistroBucketDownloadMetrics>;
type BuildDistributionBucketsActionTypes =
    | FetchBuildDistributionBucketsSuccessAction
    | FetchBuildDistributionBucketSuccessAction
    | FetchBuildDistributionBuildWorkItemsTimelineSuccessAction
    | FetchBuildDistributionBucketBuildSuccessAction
    | UpdateDistributionBucketSuccessAction
    | UpdateDistributionBucketsSuccessAction
    | FetchBuildDistributionBucketBuildsSuccessAction
    | FetchBuildDistributionSharedWithMeBuildsSuccessAction
    | NewBuildDistributionBucketSuccessAction
    | UploadBuildDistributionBuildSuccessAction
    | UpdateBuildDistributionBuildTesterNotesSuccessAction
    | ArchiveBuildDistributionBuildSuccessAction
    | ShareBuildDistributionBuildWithTestersSuccessAction
    | ArchiveBuildDistributionBucketSuccessAction
    | FetchAppStateSuccessAction
    | FetchBuildDistributionBucketDownloadMetricsSuccessAction;

type BuildDistributionBucketIdsForAppIdActionTypes =
    | NewBuildDistributionBucketSuccessAction
    | FetchAppStateSuccessAction
    | UpdateDistributionBucketsSuccessAction
    | FetchBuildDistributionBucketsSuccessAction;

function bucketIdsForAppId(
    state: BucketIdsForAppId = {},
    action: BuildDistributionBucketIdsForAppIdActionTypes,
): BucketIdsForAppId {
    switch (action.type) {
        case FETCH_APP_STATE_SUCCESS: {
            const bucketIdsForAppId = {};
            bucketIdsForAppId[action.payload.app.id] = action.payload.app.buildBuckets.map((bucket) => bucket.id);

            return {
                ...state,
                ...bucketIdsForAppId,
            };
        }
        case NEW_BUILD_DISTRIBUTION_BUCKET_SUCCESS: {
            const bucketIdsForAppId = state[action.payload.appId] ?? [];
            bucketIdsForAppId.push(action.payload.bucket.id);

            return {
                ...state,
                [action.payload.appId]: uniq(bucketIdsForAppId),
            };
        }
        case FETCH_BUILD_DISTRIBUTION_BUCKETS_WITH_RECENT_BUILDS_SUCCESS: {
            const bucketIdsForAppId = state[action.payload.appId] ?? [];
            const updatedBucketsForAppId = action.payload.bucketsAndBuilds.buckets.map((bucket) => bucket.id);

            return {
                ...state,
                [action.payload.appId]: uniq(bucketIdsForAppId.concat(updatedBucketsForAppId)),
            };
        }
        case UPDATE_BUILD_DISTRIBUTION_BUCKETS_SUCCESS: {
            const bucketIdsForAppId = state[action.payload.appId] ?? [];
            const updatedBucketsForAppId = action.payload.buckets.map((bucket) => bucket.id);

            return {
                ...state,
                [action.payload.appId]: uniq(bucketIdsForAppId.concat(updatedBucketsForAppId)),
            };
        }
        default:
            return state;
    }
}

function bucketsById(
    state: BuildDistributionBucketsById = {},
    action: BuildDistributionBucketsActionTypes,
): BuildDistributionBucketsById {
    switch (action.type) {
        case UPLOAD_BUILD_DISTRIBUTION_BUILD_SUCCESS: {
            const bucketId = action.payload.bucketId;
            if (bucketId && state[bucketId] && action.payload.build) {
                const bucket = state[bucketId];
                const buildId = action.payload.build.id;
                return {
                    ...state,
                    [bucketId]: {
                        ...bucket,
                        buildIds: uniq([...(bucket.buildIds ?? []), buildId]),
                        recentBuildIds: uniq([...(bucket.recentBuildIds ?? []), buildId]),
                    },
                };
            }
            return state;
        }
        case FETCH_BUILD_DISTRIBUTION_BUCKET_SUCCESS:
        case NEW_BUILD_DISTRIBUTION_BUCKET_SUCCESS:
        case ARCHIVE_BUILD_DISTRIBUTION_BUCKET_SUCCESS:
        case UPDATE_BUILD_DISTRIBUTION_BUCKET_SUCCESS: {
            const bucket = action.payload.bucket;
            const originalBucket = state[bucket.id];

            return {
                ...state,
                [bucket.id]: {
                    ...originalBucket,
                    ...bucket,
                    disallowedActions: bucket.disallowedActions ?? originalBucket?.disallowedActions ?? [], // if disallowed actions is null, keep original disallowedActions. this can be null if sent via ws message
                },
            };
        }
        case UPDATE_BUILD_DISTRIBUTION_BUCKETS_SUCCESS: {
            const originalState = { ...state };
            action.payload.buckets.forEach((bucket) => {
                const originalBucket = originalState[bucket.id];

                originalState[bucket.id] = {
                    ...originalBucket,
                    ...bucket,
                };
            });
            return originalState;
        }
        case FETCH_BUILD_DISTRIBUTION_BUCKETS_WITH_RECENT_BUILDS_SUCCESS: {
            const originalState = { ...state };
            action.payload.bucketsAndBuilds.buckets.forEach(({ recentBuilds, ...bucket }) => {
                const originalBucket = originalState[bucket.id];

                originalState[bucket.id] = {
                    ...originalBucket,
                    ...bucket,
                    recentBuildIds: recentBuilds.map((build) => build.id),
                };
            });
            return originalState;
        }
        case FETCH_BUILD_DISTRIBUTION_BUCKET_BUILDS_SUCCESS: {
            const originalState = { ...state };
            const bucketId = action.payload.bucketId;
            const originalBucket = originalState[bucketId];

            const originalBuildIdsSet = new Set(originalBucket?.buildIds ?? []);

            action.payload.builds.forEach((build) => {
                originalBuildIdsSet.add(build.id);
            });

            originalState[bucketId] = {
                ...originalBucket,
                buildIds: Array.from(originalBuildIdsSet),
            };
            return originalState;
        }
        case FETCH_APP_STATE_SUCCESS: {
            const originalState = { ...state };

            action.payload.app.buildBuckets.forEach((bucket) => {
                const originalBucket: BuildDistributionBucket = originalState[bucket.id];
                if (originalBucket === null) {
                    originalState[bucket.id] = bucket;
                } else {
                    originalState[bucket.id] = {
                        ...originalBucket,
                        ...bucket,
                    };
                }
            });

            return originalState;
        }
        case FETCH_BUILD_DISTRIBUTION_BUCKET_BUILD_SUCCESS: {
            const originalState = { ...state };
            const bucketId = action.payload.build?.bucketId;

            if (bucketId) {
                const originalBucket = originalState[bucketId];

                if (!originalBucket) {
                    // workaround so we don't add weird buckets to the redux store. TODO: fix!
                    return originalState;
                }

                const originalBuildIdsSet = new Set(originalBucket?.buildIds ?? []);
                const originalRecentBuildIdsSet = new Set(originalBucket?.recentBuildIds ?? []);

                originalBuildIdsSet.add(action.payload.build.id);
                originalRecentBuildIdsSet.add(action.payload.build.id);

                originalState[bucketId] = {
                    ...originalBucket,
                    buildIds: Array.from(originalBuildIdsSet),
                    recentBuildIds: Array.from(originalRecentBuildIdsSet),
                };
            }

            return originalState;
        }
        default:
            return state;
    }
}

function allBucketIds(state: string[] = [], action: BuildDistributionBucketsActionTypes): string[] {
    switch (action.type) {
        case UPDATE_BUILD_DISTRIBUTION_BUCKET_SUCCESS: {
            const originalStateSet = new Set(state);
            const bucket = action.payload.bucket;
            originalStateSet.add(bucket.id);
            return Array.from(originalStateSet);
        }
        case UPDATE_BUILD_DISTRIBUTION_BUCKETS_SUCCESS: {
            const originalStateSet = new Set(state);
            action.payload.buckets.forEach((bucket) => {
                originalStateSet.add(bucket.id);
            });
            return Array.from(originalStateSet);
        }
        case NEW_BUILD_DISTRIBUTION_BUCKET_SUCCESS: {
            const originalStateSet = new Set(state);
            originalStateSet.add(action.payload.bucket.id);
            return Array.from(originalStateSet);
        }
        case FETCH_BUILD_DISTRIBUTION_BUCKETS_WITH_RECENT_BUILDS_SUCCESS: {
            const originalStateSet = new Set(state);
            action.payload.bucketsAndBuilds.buckets.forEach((bucket) => {
                originalStateSet.add(bucket.id);
            });
            return Array.from(originalStateSet);
        }
        case FETCH_BUILD_DISTRIBUTION_BUCKET_SUCCESS: {
            const originalStateSet = new Set(state);
            const bucket = action.payload.bucket;
            originalStateSet.add(bucket.id);
            return Array.from(originalStateSet);
        }
        default:
            return state;
    }
}

function buildsById(state: BucketBuildsById = {}, action: BuildDistributionBucketsActionTypes): BucketBuildsById {
    switch (action.type) {
        case FETCH_BUILD_DISTRIBUTION_BUILD_WORK_ITEMS_TIMELINE_SUCCESS: {
            const originalState = { ...state };
            const buildId = action.payload.buildId;
            const originalBuild = originalState[buildId];

            if (!originalBuild) {
                return originalState;
            }

            originalState[buildId] = {
                ...originalBuild,
                workItemsByBuild: [...(originalBuild?.workItemsByBuild ?? []), ...action.payload.items],
            };

            return originalState;
        }
        case UPDATE_BUILD_DISTRIBUTION_BUILD_TESTERS_SUCCESS: {
            const originalState = { ...state };
            const build = action.payload.build;
            if (build) {
                originalState[build.id] = build;
            }
            return originalState;
        }
        case UPLOAD_BUILD_DISTRIBUTION_BUILD_SUCCESS: {
            const originalState = { ...state };
            if (action.payload.build) {
                originalState[action.payload.build.id] = action.payload.build;
            }
            return originalState;
        }
        case FETCH_BUILD_DISTRIBUTION_BUCKETS_WITH_RECENT_BUILDS_SUCCESS: {
            const originalState = { ...state };
            action.payload.bucketsAndBuilds.buckets.forEach((bucket) => {
                bucket.recentBuilds.forEach((build) => {
                    originalState[build.id] = build;
                });
            });

            action.payload.bucketsAndBuilds.sharedWithMe.forEach((build) => {
                originalState[build.id] = build;
            });

            return originalState;
        }
        case FETCH_BUILD_DISTRIBUTION_BUCKET_BUILDS_SUCCESS: {
            const originalState = { ...state };
            action.payload.builds.forEach((build) => {
                originalState[build.id] = build;
            });
            return originalState;
        }
        case FETCH_BUILD_DISTRIBUTION_SHARED_WITH_ME_BUILDS_SUCCESS: {
            const originalState = { ...state };
            action.payload.builds.forEach((build) => {
                originalState[build.id] = build;
            });
            return originalState;
        }
        case UPDATE_BUILD_DISTRIBUTION_BUILD_TESTER_NOTES_SUCCESS: {
            const originalState = { ...state };
            const build = action.payload.build;
            originalState[build.id] = build;
            return originalState;
        }
        case FETCH_BUILD_DISTRIBUTION_BUCKET_BUILD_SUCCESS: {
            const originalState = { ...state };
            const build = action.payload.build;
            originalState[build.id] = build;
            return originalState;
        }
        case ARCHIVE_BUILD_DISTRIBUTION_BUILD_SUCCESS: {
            const originalState = { ...state };
            const build = action.payload.build;
            delete originalState[build.id];
            return originalState;
        }
        default:
            return state;
    }
}

function allBuildIds(state: string[] = [], action: BuildDistributionBucketsActionTypes): string[] {
    switch (action.type) {
        case UPLOAD_BUILD_DISTRIBUTION_BUILD_SUCCESS: {
            const originalStateSet = new Set(state);
            if (action.payload.build) {
                originalStateSet.add(action.payload.build.id);
            }
            return Array.from(originalStateSet);
        }
        case FETCH_BUILD_DISTRIBUTION_BUCKETS_WITH_RECENT_BUILDS_SUCCESS: {
            const originalStateSet = new Set(state);
            action.payload.bucketsAndBuilds.buckets.forEach((bucket) => {
                bucket.recentBuilds.forEach((build) => {
                    originalStateSet.add(build.id);
                });
            });

            action.payload.bucketsAndBuilds.sharedWithMe.forEach((build) => {
                originalStateSet.add(build.id);
            });

            return Array.from(originalStateSet);
        }
        case FETCH_BUILD_DISTRIBUTION_BUCKET_BUILDS_SUCCESS: {
            const originalStateSet = new Set(state);
            action.payload.builds.forEach((build) => {
                originalStateSet.add(build.id);
            });
            return Array.from(originalStateSet);
        }
        case FETCH_BUILD_DISTRIBUTION_SHARED_WITH_ME_BUILDS_SUCCESS: {
            const originalStateSet = new Set(state);
            action.payload.builds.forEach((build) => {
                originalStateSet.add(build.id);
            });
            return Array.from(originalStateSet);
        }
        case FETCH_BUILD_DISTRIBUTION_BUCKET_BUILD_SUCCESS: {
            const originalStateSet = new Set(state);
            const build = action.payload.build;
            originalStateSet.add(build.id);
            return Array.from(originalStateSet);
        }
        default:
            return state;
    }
}

function sharedWithMeBuildIdsForAppId(
    state: SharedBuildsForAppId = {},
    action: BuildDistributionBucketsActionTypes,
): SharedBuildsForAppId {
    switch (action.type) {
        case FETCH_BUILD_DISTRIBUTION_BUCKETS_WITH_RECENT_BUILDS_SUCCESS: {
            const originalState = { ...state };
            const appId = action.payload.appId;
            const originalStateSet = new Set(originalState[appId] ?? []);
            action.payload.bucketsAndBuilds.sharedWithMe.forEach((build) => {
                originalStateSet.add(build.id);
            });
            originalState[appId] = Array.from(originalStateSet);
            return originalState;
        }
        case FETCH_BUILD_DISTRIBUTION_SHARED_WITH_ME_BUILDS_SUCCESS: {
            const originalState = { ...state };
            const appId = action.payload.appId;

            const originalStateSet = new Set(originalState[appId] ?? []);
            action.payload.builds.forEach((build) => {
                originalStateSet.add(build.id);
            });

            originalState[appId] = Array.from(originalStateSet);
            return originalState;
        }
        default:
            return state;
    }
}

function sharedWithMeTotalCountsForAppId(
    state: SharedBuildCountsForAppId = {},
    action: BuildDistributionBucketsActionTypes,
): SharedBuildCountsForAppId {
    switch (action.type) {
        case FETCH_BUILD_DISTRIBUTION_SHARED_WITH_ME_BUILDS_SUCCESS: {
            const originalState = { ...state };
            const appId = action.payload.appId;
            originalState[appId] = action.payload.totalCount;
            return originalState;
        }
        default:
            return state;
    }
}

function downloadMetricsForBucketId(
    state: DownloadMetricsByBucketId = {},
    action: BuildDistributionBucketsActionTypes,
): DownloadMetricsByBucketId {
    switch (action.type) {
        case FETCH_BUILD_DISTRIBUTION_BUCKET_DOWNLOAD_METRICS_SUCCESS: {
            const originalState = { ...state };
            const bucketId = action.payload.bucketId;
            originalState[bucketId] = action.payload.metrics;
            return originalState;
        }
        default:
            return state;
    }
}

const buildDistributionBucketsReducer = combineReducers({
    bucketsById,
    allBucketIds,
    buildsById,
    allBuildIds,
    sharedWithMeBuildIdsForAppId,
    sharedWithMeTotalCountsForAppId,
    bucketIdsForAppId,
    downloadMetricsForBucketId,
});

export type BuildDistroReducerType = ReturnType<typeof buildDistributionBucketsReducer>;

export default buildDistributionBucketsReducer;
